<template>
	<modal
		class="section-titles-modal"
		size="medium"
		@close="close">
		<div slot="header">
			<h3>Method Description - {{ selectedPayment.label }}</h3>
		</div>
		<div slot="body">
			<div class="form-group mb-0">
				<textarea
					class="form-control"
					placeholder="Description"
					:value="description"
					@input="onChange">
				</textarea>
			</div>
		</div>
	</modal>
</template>

<script>
import modal from '@/components/Modal.vue';

export default {
	components: {
		modal,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		selectedPayment: {
			type: Object,
			default: null,
		},
		description: {
			type: String,
			default: '',
		},
	},
	data: () => ({

	}),
	methods: {
		close() {
			this.$emit('close');
		},
		onChange(e) {
			const value = e.target.value;
			this.$emit('change', value);
		},
	},
};
</script>
